import { Language } from "./langType";

export default <Language>{
  Sports: {
    "American Football": "American Football",
    Baseball: "Baseball",
    Basketball: "Basketball",
    Boxing: "Boxing",
    Chess: "Chess",
    Cricket: "Cricket",
    Darts: "Darts",
    Entertainment: "Entertainment",
    "E-Sports": "E-Sports",
    Football: "Football",
    "Formula 1": "Formula 1",
    "Gaelic Football": "Gaelic Football",
    "Generic Sport": "Generic Sport",
    Golf: "Golf",
    "Greyhound Racing": "Greyhound Racing",
    Handball: "Handball",
    "Ice Hockey": "Ice Hockey",
    IndyCar: "IndyCar",
    MMA: "MMA",
    Nascar: "Nascar",
    Politics: "Politics",
    "Rugby League": "Rugby League",
    "Rugby Union": "Rugby Union",
    Snooker: "Snooker",
    "Table Tennis": "Table Tennis",
    Tennis: "Tennis",
    "Virtual Football": "Virtual Football",
    "Virtual Greyhound Racing": "Virtual Greyhound Racing",
    "Virtual Horse Racing": "Virtual Horse Racing"
  },
  MarketTexts: {
    ToWin: "{name} to win",
    WinFirstRound: "{name} to win first round",
    FirstTouchdown: "{name} to score a touchdown first",
    FirstTry: "{name} to score a try first",
    TotalGoals: "{name} total goals",
    TotalRuns: "{name} total runs",
    TotalPoints: "{name} total points",
    TopBatsman: "{name} to be Top Batsman",
    TopBowler: "{name} to be Top Bowler",
    FirstScore: "{name} to score first"
  },
  PromoTexts: {
    Pick: "Make your picks",
    Bet: "Bet",
    Pays: "Pays"
  },
  DateTimeTexts: {
    Today: "Today",
    Tomorrow: "Tomorrow",
    Live: "Live"
  },
  ButtonTexts: {
    Draw: "Draw"
  },
  ParlayTexts: {
    Picks: "Make your picks",
    Return: "Pays",
    Stake: "Bet",
    Draw: "Draw"
  },
  H2HTexts: {
    "Goals scored": "Goals scored",
    Shots: "Shots",
    "Shots on target": "Shots on target",
    "Ball possession": "Ball possession",
    "Goals conceded": "Goals conceded",
    "Per match": "Per match",
    H2H: "H2H",
    W: "W",
    D: "D",
    L: "L"
  }
};
